import React, { useEffect, useState } from 'react';
import { BounceLoader } from 'react-spinners';
import useProducts from '../../../Hooks/useProducts';

const Spinner = () => {
    const [loading, setLoading] = useState(false);
    const [products] = useProducts();
    useEffect(() => {
        if(products.length === 0 ){
            setLoading(true);
        }else{
            setLoading(false);
        }
    }, [products.length]);
    return (
        <div style={{textAlign: 'center'}}>
            <BounceLoader size={50} color={"#FB2E86"} loading={loading} speedMultiplier={1} />
        </div>
    );
};

export default Spinner;